export default "__VITE_ASSET__6nbtg5Dx__"